import { render } from "./BTCell.vue?vue&type=template&id=4edae780&scoped=true"
import script from "./BTCell.vue?vue&type=script&lang=js"
export * from "./BTCell.vue?vue&type=script&lang=js"

import "./BTCell.vue?vue&type=style&index=0&id=4edae780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edae780"]])

export default __exports__